import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const PropsTable = makeShortcode("PropsTable");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const PropsTableRow = makeShortcode("PropsTableRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {SplitPageLayout} from '@primer/react'
`}</code></pre>
    <Note mdxType="Note">
      <p>{`If you need a more flexible layout component, consider using the `}<a parentName="p" {...{
          "href": "/PageLayout"
        }}>{`PageLayout`}</a>{` component.`}</p>
    </Note>
    <h2>{`Examples`}</h2>
    <h3>{`Minimal`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With overflowing pane content`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane>
      <Box sx={{display: 'grid', gap: 3}}>
        {Array.from({length: 5}).map((_, i) => (
          <Box key={i} as="p" sx={{margin: 0}}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam at enim id lorem tempus egestas a non ipsum.
            Maecenas imperdiet ante quam, at varius lorem molestie vel. Sed at eros consequat, varius tellus et, auctor
            felis. Donec pulvinar lacinia urna nec commodo. Phasellus at imperdiet risus. Donec sit amet massa purus.
          </Box>
        ))}
      </Box>
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With pane hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane hidden={{narrow: true}}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With content hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane divider={{regular: 'line', narrow: 'none'}}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content hidden={{narrow: true}}>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With resizable pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane resizable>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`Without dividers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header divider="none">
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane divider="none">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer divider="none">
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With pane on right`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Pane position="end">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With condensed padding`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header padding="condensed">
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane padding="condensed">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content padding="condensed">
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer padding="condensed">
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`Without padding`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header padding="none">
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane padding="none">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content padding="none">
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer padding="none">
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`Without header or footer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Pane>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={480} />
    </SplitPageLayout.Content>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With non-sticky pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane sticky={false}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With a custom sticky header`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      height: 64,
      display: 'grid',
      placeItems: 'center',
      backgroundColor: 'canvas.subtle',
      borderBottom: '1px solid',
      borderColor: 'border.default',
      zIndex: 1
    }}
  >
    Custom sticky header
  </Box>
  <SplitPageLayout>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Pane sticky offsetHeader={64}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`SplitPageLayout`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Header`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="padding" type={`| 'none'
| 'condensed'
| 'normal'`} defaultValue="'normal'" description="The amount of padding inside the header." mdxType="PropsTableRow" />
  <PropsTableRow name="divider" type={`| 'none'
| 'line'
| {
    narrow?:
      | 'none'
      | 'line' 
      | 'filled'
    regular?:
      | 'none'
      | 'line'
    wide?:
      | 'none'
      | 'line'
  }`} defaultValue="'line'" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the header is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Content`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="width" type={`| 'full'
| 'medium'
| 'large'
| 'xlarge'`} defaultValue="'large'" description="The maximum width of the content region." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'condensed'
| 'normal'`} defaultValue="'normal'" description="The amount of padding inside the content." mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Pane`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="position" type={`| 'start'
| 'end'
| {
    narrow?:
      | 'start'
      | 'end'
    regular?:
      | 'start'
      | 'end'
    wide?:
      | 'start'
      | 'end'
  }`} defaultValue="'start'" mdxType="PropsTableRow" />
  <PropsTableRow name="width" type={`| 'small'
| 'medium'
| 'large'`} defaultValue="'medium'" description="The width of the pane." mdxType="PropsTableRow" />
  <PropsTableRow name="resizable" type="boolean" defaultValue="false" description="When true, the pane may be resized by the user." mdxType="PropsTableRow" />
  <PropsTableRow name="widthStorageKey" type="string" defaultValue="'paneWidth'" description="Provide a key used by localStorage to persist the size of the pane on the client." mdxType="PropsTableRow" />
  <PropsTableRow name="sticky" type="boolean" defaultValue="true" description="Whether the pane should stick to the top of the screen while the content scrolls." mdxType="PropsTableRow" />
  <PropsTableRow name="offsetHeader" type="number | string" defaultValue="0" description="Use offsetHeader along with the sticky prop to push the sticky pane down to make room for a sticky header if necessary. Use the type `string` to specify the height with a unit i.e. 5rem; otherwise the type `number` will be taken as px." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'condensed'
| 'normal'`} defaultValue="'normal'" description="The amount of padding inside the pane." mdxType="PropsTableRow" />
  <PropsTableRow name="divider" type={`| 'none'
| 'line'
| {
    narrow?:
      | 'none'
      | 'line' 
      | 'filled'
    regular?:
      | 'none'
      | 'line'
    wide?:
      | 'none'
      | 'line'
  }`} defaultValue="'line'" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the pane is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Footer`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="padding" type={`| 'none'
| 'condensed'
| 'normal'`} defaultValue="'normal'" description="The amount of padding inside the footer." mdxType="PropsTableRow" />
  <PropsTableRow name="divider" type={`| 'none'
| 'line'
| {
    narrow?:
      | 'none'
      | 'line' 
      | 'filled'
    regular?:
      | 'none'
      | 'line'
    wide?:
      | 'none'
      | 'line'
  }`} defaultValue="'line'" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`| boolean
| {
    narrow?: boolean
    regular?: boolean
    wide?: boolean
  }`} defaultValue="false" description="Whether the footer is hidden." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      